import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    async getProductsByCode(_, code) {
      return window.$axios.get('product-new?include=prices.companyType&code=' + code);
    },
    async getProductsByCodes(_, { codes, companyTypeId, sort }) {
      let endPoint = 'product-new?include=prices.companyType';
      if (sort) {
        endPoint += '&sort=id';
      }
      for (const code in codes) {
        endPoint += '&code[]=' + codes[code];
      }
      if (companyTypeId) {
        endPoint += '&company_type_id=' + companyTypeId;
      }
      return window.$axios.get(endPoint);
    },
    async getProductsByAddionalProduct(_, { codes, companyId }) {
      let endPoint = 'company/' + companyId + '/product?include=prices.companyType&is_addional_product=1';
      for (const code in codes) {
        endPoint += '&code[]=' + codes[code];
      }
      return window.$axios.get(endPoint);
    },
    async getProducts(_, filters) {
      return window.$axios.get('product-new', {
        params: filters,
      });
    },
  },
});
